"use strict";
import 'materialize-css';
import './sidenav';
import './scripts';
import './ocr';
